<template>
  <div class="filter-recap">
    <div class="filters-list" v-if="filters.length">
      <b-nav class="filters-list__list nav">
        <li v-for="filter in filters" :key="filter.value" class="filters-list__list__item">
          <button class="btn btn-icon active-filter value" @click.prevent="removeFilter(filter.value, filter.attrCode)">
            <span class="remove-filter">
              <svg class="o-icon"><use xlink:href="#close"></use></svg>
            </span>
            <span class="filter-label">{{filter.label}}</span>
          </button>
        </li>
      </b-nav>
      <div class="total-filters">
        <span class="value">{{filters.length}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      filtersSelected: 'listing/filterSelected',
      filterParentMap: 'listing/filterParentMap'
    }),
    filters () {
      let _this = this
      let filters = []
      for (let i in this.filtersSelected) {
        this.filtersSelected[i].forEach(value => {
          if (Object.keys(_this.filterParentMap).length > 0) {
            filters.push({
              'attrCode': i,
              label: (_this.filterParentMap[value]) ? _this.filterParentMap[value].label : value,
              value: (_this.filterParentMap[value]) ? _this.filterParentMap[value].value : value
            })
          }
        })
      }
      return filters
    }
  },
  methods: {
    removeFilter (newValues, attrCode) {
      // find filter selected in fileterSelected and remove
      let filters = []
      if (newValues && this.filtersSelected[attrCode] && this.filtersSelected[attrCode].length) {
        filters = this.filtersSelected[attrCode].filter(function (filter) {
          return filter !== newValues
        })
        this.$store.commit('listing/updateFilters', { attrCode: attrCode, valueSelected: filters })
      } else {
        this.$store.commit('listing/clearFilters')
      }
      this.$emit('changeFilter')
    }
  }
}
</script>
